import styled from "styled-components"


export const Container = styled.label`
    border: 1px solid ${props => props.theme.colors.silverSand};
    border-radius: 4px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    width: 100%;
    &:active {
        border: 1px solid ${props => props.theme.colors.white};
    }
    input {
        height: 100%;
        width: 100%;
        outline: none;
        border: none;
        background: transparent;
        color: ${props => props.theme.colors.white};
        &::placeholder {
            color: ${props => props.theme.colors.silverSand};
        }
    }
    svg {
        margin-right: 10px;
        width: 20px;
        height: 20px;
        min-width: 20px;
        path {
            fill: ${props => props.theme.colors.skyblue}
        }
    }
`